import React from 'react'
import { AdminTransfer } from 'src/core/models'
import TransferDetailsButton from './TransferDetailsButton/TransferDetailsButton'
import TransferValidateButton from './TransferValidateButton/TransferValidateButton'
import TransferRejectButton from './TransferReject/TransferRejectButton/TransferRejectButton'

const TransferListActionsColumn: React.FC<{ transfer: AdminTransfer }> = ({ transfer }) => {
  return <div className='centered'>
    {/* Details */}
    <TransferDetailsButton transfer={transfer} />
    {/* Validate */}
    <TransferValidateButton transfer={transfer} />
    {/* Reject */}
    <TransferRejectButton transfer={transfer} />

  </div>
}

export default TransferListActionsColumn
